const playVideoBtn = document.querySelector('.sizzle-reel__wrapper__play');

if (playVideoBtn) {
    const iframe = document.querySelector(
        '.sizzle-reel__iframe-container iframe'
    );
    const player = new Vimeo.Player(iframe);
    const videoJS = document.querySelector('.sizzle-reel__js');
    const video = document.querySelector('.sizzle-reel__wrapper');
    const closeVideoBtn = document.querySelector('.sizzle-reel__js__close');

    playVideoBtn.addEventListener('click', function () {
        videoJS.classList.remove('dn');
        video.classList.add('dn');
        player.setVolume(0.3);
        player.play();
    });

    closeVideoBtn.addEventListener('click', function () {
        video.classList.remove('dn');
        videoJS.classList.add('dn');
        player.pause();
        player.setCurrentTime(0);
    });
}
